import {AfterViewChecked, Component, DoCheck, ElementRef, HostListener, Input, OnInit, Output} from '@angular/core';
import {
  simpleValueAccessorProvider,
  SimpleValueAccessorSupportComponent
} from '../../../util/angular/simple-value-accessor'
import {UntypedFormControl, UntypedFormGroup, ValidationErrors, Validators} from '@angular/forms';
import {EventEmitter} from '@angular/core';

@Component({
  selector: 'shared-select-input',
  templateUrl: 'select-input.component.html',
  styleUrls: ['select-input.component.scss'],
  providers: [simpleValueAccessorProvider(SelectInputComponent)]
})

export class SelectInputComponent extends SimpleValueAccessorSupportComponent<{kod: string, dodatkowyOpis: string}> implements OnInit, AfterViewChecked {
  private readonly INPUT_ACTIVATION_CODE: string = 'INN';

  @Input()
  list = [] as { kod: string, opis: string }[];

  @Input()
  optionWithInput?: string;

  @Input()
  inputPlaceholder?: string;

  @Output()
  validatePassEmit = new EventEmitter<boolean>();

  @Input()
  selectFirstFromList?: boolean;

  selectedElement = null as unknown as { kod: string, opis: string }
  input = false;
  optionPanelOpen = false;
  causeFormGroup!: UntypedFormGroup;
  validatePass = false;

  constructor(private eRef: ElementRef) {
    super();
  }

  ngOnInit(): void {
    if (this.optionWithInput) {
      this.list.push({kod: this.INPUT_ACTIVATION_CODE, opis: this.optionWithInput});
      this.causeFormGroup = new UntypedFormGroup({
        cause: new UntypedFormControl(this.value, [Validators.maxLength(255)]),
      })
    }
  }

  ngAfterViewChecked(): void {
    if (this.selectFirstFromList) {
      this.onSelectionChange({kod: this.list[0].kod, opis: this.list[0].opis})
    }
  }

  onSelectionChange(changes: { kod: string; opis: string }): void {
    this.selectedElement = changes;
    this.input = changes.kod === this.INPUT_ACTIVATION_CODE;

    const element = this.list.find((o: { kod: string; }) => o.kod === changes.kod)
    if (element !== undefined) {
      this.resettingForm();
      this.value = {kod: element.kod, dodatkowyOpis: this.causeFormGroup?.value.cause };
      this.valueChanged()
    }
    if (!this.input) {
      this.validatePassEmit.emit(true);
    }
  }

  onInputChange(): void {
    this.value.dodatkowyOpis = this.causeFormGroup.value.cause;
  }

  validateLength(errors?: ValidationErrors): boolean {
    if (!this.causeFormGroup.value.cause) {
      this.validatePass = false;
      this.validatePassEmit.emit(this.validatePass);
      return false;
    }

    if (errors) {
      this.validatePass = false;
      this.validatePassEmit.emit(this.validatePass);
      return true;
    }

    this.valueChanged()
    this.validatePass = true;
    this.validatePassEmit.emit(this.validatePass);
    return false;
  }

  private resettingForm(): void {
    if (this.causeFormGroup?.value.cause) {
      this.causeFormGroup.reset();
    }
  }

  @HostListener('document:click', ['$event'])
  clickOut(event: { target: any; }): void {
    if (!this.eRef.nativeElement.contains(event.target) && !event.target.classList.contains('c-select__item')) {
      this.optionPanelOpen = false
    } else if (event.target.classList.contains('c-select__title')) {
      this.optionPanelOpen = !this.optionPanelOpen
    }
  }
}
